import React, { useEffect, useState } from "react";
import ChartPreview from "./ChartPreview";
import { useParams } from "react-router-dom";

const DashboardView = () => {
  const { studyname } = useParams(); // e.g. /dashboard/study1
  const [config, setConfig] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [apiData, setApiData] = useState({}); // stores fetched KPI data

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(`/data/${studyname}.json`);
        const json = await response.json();
        setConfig(json);
        if (json.tabs.length > 0) setActiveTab(json.tabs[0].id);
      } catch (error) {
        console.error("Error loading dashboard config:", error);
      }
    };
    fetchConfig();
  }, [studyname]);

  useEffect(() => {
    if (config) {
      // Fetch data for each KPI
      config.tabs.forEach((tab) => {
        tab.kpis.forEach(async (kpi) => {
          try {
            // You can replace this mock API with your real one later
            const res = await fetch(kpi.api);
            const data = await res.json();
            setApiData((prev) => ({ ...prev, [kpi.id]: data }));
          } catch {
            // fallback if API fails
            setApiData((prev) => ({
              ...prev,
              [kpi.id]: [
                { name: "A", value: 200 },
                { name: "B", value: 300 },
                { name: "C", value: 150 },
              ],
            }));
          }
        });
      });
    }
  }, [config]);

  if (!config) {
    return (
      <div className="flex justify-center items-center h-screen text-gray-500">
        Loading dashboard...
      </div>
    );
  }

  const activeTabData = config.tabs.find((tab) => tab.id === activeTab);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">
        Dashboard — {studyname.toUpperCase()}
      </h1>

      {/* Global Filters */}
      <div className="flex gap-3 mb-4">
        {config.globalFilters.map((filter) => (
          <select
            key={filter.id}
            className="border p-2 rounded"
            defaultValue=""
          >
            <option value="" disabled>
              {filter.label}
            </option>
            <option>Option 1</option>
            <option>Option 2</option>
          </select>
        ))}
      </div>

      {/* Tabs */}
      <div className="flex mb-4 border-b">
        {config.tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 ${
              activeTab === tab.id
                ? "border-b-2 border-blue-600 font-semibold"
                : "text-gray-500"
            }`}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {/* Tab Filters */}
      <div className="flex gap-3 mb-4">
        {activeTabData.filters.map((filter) => (
          <select
            key={filter.id}
            className="border p-2 rounded"
            defaultValue=""
          >
            <option value="" disabled>
              {filter.label}
            </option>
            <option>Option 1</option>
            <option>Option 2</option>
          </select>
        ))}
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-3 gap-6">
        {activeTabData.kpis.map((kpi) => (
          <div
            key={kpi.id}
            className="border p-3 rounded-xl bg-white shadow-md"
          >
            <h3 className="font-medium mb-2">{kpi.label}</h3>
            <ChartPreview
              type={kpi.type}
              label={kpi.label}
              data={apiData[kpi.id]}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardView;
